module.exports = __webpack_public_path__ + "static/media/aggjakten2026_u8.91c7e74d.jpg";